<template>
  <div
    class="login-message-box h-screen flex w-full password-expired c8f3fc8c0"
  >
    <div
      class="
        vx-col
        flex
        items-center
        justify-center
        flex-col
        sm:w-1/2
        md:w-3/5
        lg:w-3/4
        xl:w-1/2
        mx-auto
        text-center
      "
    >
      <main class="cc093f93e c2fcaeec2">
        <section class="c8b8c0471 _prompt-box-outer">
          <div class="cdb783af6 c00fb6851">
            <div class="c770b42ed">
              <header class="c18bb39aa cb81a5b1b">
                <img
                  class="c3f19b978 cfb2b2435"
                  id="prompt-logo-center"
                  src="https://d2njceor6n4d02.cloudfront.net/logos/fisg.png"
                  :alt="title"
                />
                <h1 class="cc8f17e22 c23bcc757" v-if="title">{{ title }}</h1>

                <div class="c012388dd ccfe7e5aa">
                  <p class="ce43a1d56 c3667a73b">
                    <slot></slot>
                  </p>
                </div>
              </header>

              <div class="c05438d4c c92c51a79" v-if="action">
                <div class="c31c19401">
                  <button
                    @click="action"
                    class="ccec01e3d c11179b9b ca260d696 cbb135b31 cf0841a67"
                  >
                    {{ buttonLabel }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginMessageBox',

  props: {
    title: String,
    buttonLabel: String,
    action: Function
  }
};
</script>

<style>
.login-message-box {
  background: #000000;
  font-family: ulp-font, -apple-system, BlinkMacSystemFont, Roboto, Helvetica,
    sans-serif;
}
.c11179b9b {
  background-color: #f9db2b;
  color: #333c4d;
}
</style>